








































import { Component, Vue } from 'vue-property-decorator';
import { ICart, ICartItem, IProduct } from '@/models/CartModels';

@Component({
})
export default class Carts extends Vue {
  public carts: ICart[] = [];

  public doNothing() {
    return true;
  }
}
